<!-- 
  /** 
  * @author Mau de Pallares 
  * @company Erillam Healthcare 
  * @version 2.0 
  */ -->
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.registrationDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.registrationDate) }}
      </template>
      <template v-slot:[`item.actions`]="{ item, index }">
        <v-tooltip top :index="index">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="openDialogCreateAppointment(item.idPatient)">
              <v-icon v-bind="attrs" v-on="on"> mdi-calendar </v-icon>
            </v-btn>
          </template>
          <span>Agendar cita {{ item.idPatient }} </span>
        </v-tooltip>
        <menu-crud
          :index="index"
          :getItem="get"
          :paramsGet="{ idPatient: item.idPatient }"
        />
      </template>
    </v-data-table>
    <v-dialog v-model="appointmentDialog" persistent max-width="70%">
      <schedule-appointment-dialog
        :idPatient="idPatient"
        @closeCancelationDialog="closeAppointmentDialog"
        :closeDialog="closeDialogCreateAppointment"
      />
    </v-dialog>
  </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import ScheduleAppointmentDialog from "@/app/components/reception/ScheduleAppointmentDialog.vue";

export default {
  name: "PatientTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    updateStatus: Function,
    itemsPerPage: Number,
  },
  components: {
    MenuCrud,
    ScheduleAppointmentDialog,
  },
  data() {
    return {
      idPatient: null,
      appointmentDialog: false,
      dataModal: {},
      dialogCancelation: false,
      headers: [
        {
          text: "Id paciente",
          value: "idPatient",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "Paciente",
          value: "person.fullName",
          align: "center",
          sortable: false,
        },
        {
          text: "CURP",
          value: "person.curp",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha de registro",
          value: "registrationDate",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
    };
  },
  methods: {
    // openDialogCreateAppointment(idPatient) {
    //   this.idPatient = idPatient;
    //   this.appointmentDialog = true;
    // },
    openDialogCreateAppointment(idPatient) {
      this.sending = true;
      this.loader = true;
      this.$router.push({
        name: "CrearCita",
        params: { idPatient: idPatient },
      });
    },
    closeDialogCreateAppointment() {
      this.idPatient = null;
      this.appointmentDialog = false;
    },
    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeAppointmentDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
  },
};
</script>
